import React from 'react';
import './ConsultantBlock.scss';


const ITConsultingBlock = () => {
    const handleFindOutMoreClick = () => {
        const targetSection = document.getElementById('our-service-section');
        if (targetSection) {
            targetSection.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <div>
            <div className="it-consulting-block">
                <h2>MajorityAI - Enterprise AI & Machine Learning Solutions</h2>
                <div className="content-wrapper">
                    <p className="main-description">
                        MajorityAI builds enterprise-grade AI systems using Large Language Models (LLMs), Retrieval-Augmented Generation (RAG), and advanced multi-agent frameworks for businesses across Australia and New Zealand.
                    </p>
                    <p className="service-details">
                        Transform your business with: custom AI model development, intelligent automation, computer vision solutions, and end-to-end MLOps implementation.
                    </p>
                </div>
                <button className="find-out-more-btn" onClick={handleFindOutMoreClick}>
                    Find out more
                </button>
            </div>
        </div>
    );
};

export default ITConsultingBlock;